import { render, staticRenderFns } from "./MainNavigationItem.vue?vue&type=template&id=40887382&"
import script from "./MainNavigationItem.vue?vue&type=script&lang=js&"
export * from "./MainNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports